import {
  DeliveryCompany,
  DeliveryCompanyAggregates
} from "../../deliveryCompanies.types";
import { CompanyAvatar } from "../CompanyAvatar";

import styles from "./CompanyDetailsHeader.module.scss";

interface CompanyDetailsHeaderProps {
  company: DeliveryCompany;
  aggregates?: DeliveryCompanyAggregates | null;
}

const CompanyDetailsHeader = ({
  company,
  aggregates
}: CompanyDetailsHeaderProps) => {
  const activeDrivers = aggregates?.activeDriverCount ?? 0;
  const totalDrivers = aggregates?.totalDriverCount ?? 0;
  const capacityUsed = aggregates?.capacityUsed ?? 0;
  const capacityMax = company.capacity || 0;
  const capacityPercent =
    capacityMax > 0 ? Math.round((capacityUsed / capacityMax) * 100) : 0;

  return (
    <div className={styles.header}>
      <div className={styles.header__main}>
        <CompanyAvatar
          id={company.id}
          name={company.name}
          avatarUrl={company.avatar?.url}
          size={72}
          borderRadius={16}
        />
        <div className={styles.header__info}>
          <h2 className={styles.header__name}>{company.name}</h2>
          <div className={styles.header__contacts}>
            {company.phoneNumber ? <span>{company.phoneNumber}</span> : null}
            {company.phoneNumber && company.email ? (
              <span className={styles.header__contactsDot}>·</span>
            ) : null}
            {company.email ? <span>{company.email}</span> : null}
          </div>
        </div>
      </div>

      <div className={styles.header__kpis}>
        <div className={styles.header__kpi}>
          <span className={styles.header__kpiValue}>
            {activeDrivers} / {totalDrivers}
          </span>
          <span className={styles.header__kpiLabel}>Active drivers</span>
        </div>
        <div className={styles.header__kpiSeparator} />
        <div className={styles.header__kpi}>
          <span className={styles.header__kpiValue}>
            {capacityUsed} / {capacityMax}{" "}
            <span className={styles.header__kpiPercent}>
              ({capacityPercent}%)
            </span>
          </span>
          <span className={styles.header__kpiLabel}>Capacity used</span>
        </div>
      </div>
    </div>
  );
};

export default CompanyDetailsHeader;
